import { render, staticRenderFns } from "./CsvFileTable.vue?vue&type=template&id=5af4cba9&"
import script from "./CsvFileTable.vue?vue&type=script&lang=ts&"
export * from "./CsvFileTable.vue?vue&type=script&lang=ts&"
import style0 from "./CsvFileTable.vue?vue&type=style&index=0&id=5af4cba9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports